import { Bot, HelpCircle, Info } from "lucide-react";
import { ProposalCard } from "@/components/assistant/ProposalCard";

function AnswerCard({ a, testid }) {
  return (
    <div className="mt-3 rounded-md border border-blue-200 bg-blue-50/60 p-3" data-testid={testid}>
      <div className="mb-1.5 flex items-center gap-1.5 text-sm font-semibold text-blue-900"><Info className="h-4 w-4" />{a.title}</div>
      <ul className="space-y-1 text-sm text-slate-700">{a.lines.map((l, i) => <li key={i} className="font-mono text-xs leading-relaxed">{l}</li>)}</ul>
    </div>
  );
}

export function MessageBubble({ m, idx, chat }) {
  if (m.role === "user") {
    return (
      <div className="flex justify-end sk-rise" data-testid={`assistant-message-${idx}`} data-role="user">
        <div className={`max-w-[85%] whitespace-pre-wrap rounded-2xl rounded-br-sm bg-slate-900 px-4 py-2.5 text-sm text-white ${m.pending ? "opacity-60" : ""}`}>{m.text}</div>
      </div>
    );
  }
  return (
    <div className="flex gap-2.5 sk-rise" data-testid={`assistant-message-${idx}`} data-role="assistant">
      <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-orange-500 text-slate-950"><Bot className="h-4 w-4" /></div>
      <div className="min-w-0 flex-1 rounded-2xl rounded-tl-sm border bg-white px-4 py-3 text-sm shadow-sm">
        {m.text && <p className="text-slate-800" data-testid={`assistant-reply-${idx}`}>{m.text}</p>}
        {m.answers?.map((a, i) => <AnswerCard key={i} a={a} testid={`answer-card-${idx}-${i}`} />)}
        {m.clarification && (
          <div className="mt-3 flex gap-2 rounded-md border border-amber-200 bg-amber-50 p-3 text-amber-900" data-testid={`clarification-${idx}`}>
            <HelpCircle className="mt-0.5 h-4 w-4 shrink-0" /><span>{m.clarification}</span>
          </div>
        )}
        {m.proposal && <ProposalCard proposal={m.proposal} idx={idx} busy={chat.busyMsg === m.id} onConfirm={() => chat.confirm(m.id)} onCancel={() => chat.cancel(m.id)} />}
      </div>
    </div>
  );
}
